import styled from 'styled-components';
import { baseTyping } from '@designSystem/typings';
import colors from '@designSystem/colors';
import breakpoints from '@designSystem/breakpoints';
import DropDown from '@designSystem/dropDown';
import { ExactDateFilter } from '@root/src/app/designSystem/dateFilter';

export const StyledTile = styled.div`
  cursor: default;
  box-sizing: border-box;
  border: 2px solid ${colors.white};

  ${baseTyping}
  font-size: 14px;
  color: ${colors.black};

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  flex: 1;

  height: 136px;
  margin: 5px;

  background: ${colors.white};
  border-radius: 6px;

  &:hover {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  }

  &[aria-selected='true'] {
    border: 2px solid ${colors.green};
  }

  @media (max-width: ${breakpoints.large}) {
    font-size: 16px;
    color: ${colors.darkGrey};
    width: max-content;

    padding: 4px 16px;
    border-radius: 100px;
    height: 32px;
    flex: max-content;

    &[aria-selected='true'] {
      color: ${colors.green};
    }
  }
`;

export const StyledCircle = styled.div`
  cursor: default;
  font-size: 24px;
  color: ${colors.black};

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  position: static;
  width: 64px;
  height: 64px;
  left: calc(50% - 64px / 2);
  top: calc(50% - 64px / 2);

  background: ${colors.lightGrey};
  border-radius: 100px;

  &[aria-selected='true'] {
    color: ${colors.green};
    background: ${colors.lightGreen};
  }

  @media (max-width: ${breakpoints.large}) {
    display: none;
  }
`;

export const DesktopFlexRowContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DesktopFilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin: 35px 5px 0px 5px;
`;

export const MobileFilterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 16px;

  & > div:first-child {
    padding: 16px 0px;
  }

  & > div {
    padding: 8px 0px;
  }
`;

export const MobileFlexRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (max-width: ${breakpoints.large}) {
    width: max-content;
    margin: 0 auto;
  }
`;

export const MobileSearchButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  width: 32px;
  height: 32px;
  cursor: pointer;

  background-color: ${colors.green};

  & svg {
    & path {
      stroke: ${colors.white};
    }
  }
`;

export const MobileHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 44px;

  & svg {
    cursor: pointer;
  }
`;

export const CustomDropdown = styled(DropDown)`
  display: flex;
  flex-shrink: 1;
`;

export const CustomDatepicker = styled(ExactDateFilter)`
  display: flex;
  flex-shrink: 0;
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;

  & > div {
    margin: 0 24px 0 24px;
  }
`;

export const WrapContainer = styled.div`
  width: 100%;

  @media (max-width: 530px) {
    overflow-x: scroll;

    &::-webkit-scrollbar {
      width: 0;
    }
  }
`;
